module.exports = {
  locales: ['no-no'],
  defaultLocale: 'no-no',
  localeDetection: false,
  defaultNS: 'common',
  pages: {
    '/[mainSubpage]': ({ params, locale }) => {
      return locale.includes('da-dk') && params.mainSubpage.includes('karriere') ? ['english'] : [];
    },
    '*': [
      'aria',
      'category',
      'common',
      'content_type',
      'location',
      'multiple',
      'sector',
      'segment',
      'service_line',
      'service',
      'theme_topic',
      'url',
      'workplace',
      'market',
      'career_stage',
    ],
  },
};
